import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 14 14"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "m1.431 1.968 4.51 3.383c.8.6 1.9.6 2.7 0l4.51-3.383a1.032 1.032 0 0 0-.791-.59l-.242-.035a34.132 34.132 0 0 0-9.654 0l-.241.035c-.353.05-.648.277-.792.59Zm11.996 1.669L9.54 6.55a3.75 3.75 0 0 1-4.5 0L1.156 3.637a25.794 25.794 0 0 0 .195 7.073c.074.444.427.788.872.852l.241.035c3.202.457 6.453.457 9.654 0l.242-.035c.445-.064.798-.408.872-.852.39-2.34.455-4.72.195-7.073Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }